/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { Point } from 'geojson';
import { BaseService } from '../../service/base';

export interface NonReportingDTO {
    id: string;
    lastSeen: number;
}

export interface FleetInformationDTO {
    id: string;
    name: string;
    currentOdometer: number;
    currentHours: number;
    errorCodes: string;
    lastPosition: Point;
    currentState: number;
    odometerOffsetKm: number;
    hoursOffset: number;
}

export interface FleetDailyStat {
    assetId: string;
    name: string;
    odometer: number;
    hours: number;
}

export interface DiagnosticDTO {
    today: DiagnosticOdometerDTO[];
    //yesterday: Array<DiagnosticHoursDTO>;
    //week: Array<DiagnosticHoursDTO>;
    month: DiagnosticOdometerDTO[];
    id: string;
}

export interface DiagnosticOdometerDTO {
    assetid: string;
    odometer: number;
    timestamp: string;
    local: string;
}

/**
 * See
 *      /microservice/src/main/java/com/dynamiciotdata/microservice/controller/trip/TripDTO.java
 */
export interface TripDTO {
    distanceKm: number;
    timeSeconds: number;
    idleTimeSeconds: number;
    startTimeMSeconds: number;
}

export class VisionFleetService extends BaseService {
    async getInfo() {
        const response = await this.get<FleetInformationDTO[]>(this.url + '/api/' + this.orgid + '/fleet/info');
        return response;
    }

    async getTodayHours(id: string) {
        const response = await this.get<DiagnosticDTO>(this.url + '/api/' + this.orgid + '/fleet/' + id);
        return response;
    }

    async getDailyStats() {
        const response = await this.get<FleetDailyStat[]>(this.url + '/api/' + this.orgid + '/fleet/dailystats');
        return response;
    }

    async getTripData(assetid: string) {
        const now = new Date();
        const startUTC = Math.floor(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()));
        const endUTC = startUTC + 86399999; // 24*60*60 - 1

        const response = await this.get<TripDTO[]>(this.url + '/api/' + this.orgid + '/event/trip?' + 'assetid=' + assetid + '&start=' + startUTC + '&end=' + endUTC);
        return response;
    }

    async setOdometer(rId: string | number, newOdometer: number) {
        const response = await this.get<FleetInformationDTO>(this.url + '/api/' + this.orgid + '/fleet/odometer?id=' + rId + '&' + 'odo=' + newOdometer);
        return response;
    }

    async setHours(rId: string | number, newHours: number) {
        const response = await this.get<FleetInformationDTO[]>(this.url + '/api/' + this.orgid + '/fleet/hours?id=' + rId + '&' + 'hours=' + newHours);
        return response;
    }

    async getNonReportingVehicles() {
        const response = await this.get<NonReportingDTO[]>(this.url + '/api/' + this.orgid + '/fleet/nonreport?days=3');
        return response;
    }
}
